import { isNullOrWhitespace } from '@yembo/yemblocks-core/dist/_util';

export const getFullName = (
  user: { givenName: string | null; familyName: string | null } | null,
  defaultText = '--'
): string => {
  if (!user) return defaultText;

  try {
    const { givenName, familyName } = user;
    const hasName = !(isNullOrWhitespace(givenName) && isNullOrWhitespace(familyName));
    if (hasName) {
      // The API returns either part as null, so coalesce rather than
      // interpolating the literal "null" into the displayed name.
      return `${givenName ?? ''} ${familyName ?? ''}`.trim();
    } else {
      throw new Error('No name provided');
    }
  } catch {
    return defaultText;
  }
};
